import { render, staticRenderFns } from "./TinyCourseCard.vue?vue&type=template&id=30d748ee"
import script from "./TinyCourseCard.vue?vue&type=script&lang=js"
export * from "./TinyCourseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports